import { useNavigate } from "react-router-dom";

import axios from 'axios';
import Storages from '../helper/storages'
import useEndpoints from "../api/useEndpoints";
import errorHandler from "../api/errorHandler";
import { useState, useRef } from "react";

import Toast from './toast'
import paths from '../config/paths.json'

import { AiOutlineEyeInvisible, AiOutlineEye } from 'react-icons/ai'
import Captcha from "./captcha";
import initUserInfo from "../api/initUserInfo";
import LoginHeader from "./loginHeader";
import { fa2En } from '../helper/InputHelper'
import { useMediaQuery } from 'react-responsive'
import toast from "./toast";
import AddOriginAddress from "../modals/addOriginAddress";
import { height } from "@mui/system";

export default function Login() {
  const endpoints = useEndpoints();
  const navigate = useNavigate();
  const [state, setState] = useState()
  const [loading, setLoading] = useState(false)
  const [challengeId, setChallengeId] = useState()
  const isMobile = useMediaQuery({ query: `(max-width: 767px)` });
  var logo = require(`../assets/images/${process.env.REACT_APP_ENV}/logo.png`)
  var bg_sm = require(`../assets/images/${process.env.REACT_APP_ENV}/bg-sm.jpg`)
  var bg_lg = require(`../assets/images/${process.env.REACT_APP_ENV}/bg-lg.jpg`)

  var onRegisterUser = (parameters) => {

    if (!parameters?.mobile) {
      toast.Error("شماره همراه وارد  نشده است")
      return
    }

    if (!parameters?.name) {
      toast.Error("نام خود را وارد  کنید")
      return
    }
    if (!parameters?.defAddress) {
      toast.Error("آدرس را وارد  کنید")
      return
    }

    // if (!challengeId) {
    //   toast.Error("بروی من ربات نیستم کلیک کنید")
    //   return
    // }

    setLoading(true)
    var params = {
      mobile: fa2En(parameters?.mobile),
      name: fa2En(parameters?.name),
      mail: fa2En(parameters?.mail),
      lat: fa2En(parameters?.lat),
      lng: fa2En(parameters?.lng),
      defAddress: fa2En(parameters?.defAddress),
      findAddress: fa2En(parameters?.findAddress),
      tel: fa2En(parameters?.tel),
      // challengeId: challengeId
      challengeId: '123'
    }
    axios.get(endpoints.mobileIdentity,
      {
        params: params
      }, {
      headers: { 'x-auth-token': Storages.getUserToken() },
    }).then((res) => {
      toast.Success(res.data.result.msg)
      Storages.setAllowReqAfterSec(new Date().getTime() + (res?.data?.result?.allowReqAfterSec * 1000))
      Storages.setHashedPhoneNumber(res?.data?.result?.phoneNumberHashed)
      navigate(paths.registerVerify, { state: params })
    }).catch((e) => {
      errorHandler(e)
    }).then(() => {
      setLoading(false)
    })
  }



  let onInputChange = (e) => {

    try {
      let name = e.target.name;
      let value = e.target.value;
      setState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } catch (e) {
      console.log(e);
    }
  };

  var submit = useRef()

  const handleEnterToSubmit = (event) => {
    if (event.key.toLowerCase() === "enter") {
      submit.current.focus();
    }
  };


  const handleEnter = (event) => {
    if (event.key.toLowerCase() === "enter") {
      const form = event.target.form;
      const index = [...form].indexOf(event.target);
      form.elements[index + 1].focus();
      event.preventDefault();
    }
  };


  return (

    <div >

      <div className="d-flex justify-content-center align-items-center  vh-100 overflow-auto bg-danger" style={{ top: 0, right: 0, bottom: 0, left: 0 }} >

        <div className="w-100 vh-100 position-absolute bg-dark align-items-center overflow-hidden  justify-content-center d-flex ">
          {
            isMobile ?
              <img className="center-cropped " src={bg_sm} />
              :
              <img className="  center-cropped " src={bg_lg} />
          }
        </div>

        <div className="d-flex flex-column justify-content-center align-items-center col-10  col-sm-6 col-md-5 col-lg-3   ">

          <div className="card p-3 col-12 " autoComplete="on"  >
            <div className="d-flex w-100 justify-content-center align-items-center trans ">
              <img style={{ width: '9rem' }} className="position-absolute top-0 mt-2 start-50 translate-middle" src={logo} />
            </div>

            <h5 className="justify-content-center align-items-center d-flex iranSansBold mt-5">صفحه ثبت نام</h5>

            <form>

              <div className="form-group pt-2 autocomp">
                <label htmlFor="mobile" className="pb-1">شماره همراه *</label>
                <input type="number" className="form-control" name="mobile" placeholder="شماره همراه"
                  onChange={onInputChange}
                  onKeyDown={handleEnter} />
              </div>

              <div className="form-group pt-2 autocomp">
                <label htmlFor="name" className="pb-1">نام و نام خانوادگی *</label>
                <input type="text" className="form-control" name="name" placeholder="نام و نام خانوادگی"
                  onKeyDown={handleEnter}
                  onChange={onInputChange} />
              </div>
              <AddOriginAddress
                onClose={() => {

                }}
                eshCode={undefined}

                onResult={(location) => {


                  setState((prevState) => ({
                    ...prevState,
                    lat: location?.lat,
                    lng: location?.lng,
                    defAddress: location?.fullAddress,
                    findAddress: location?.findAddress

                  }));
                  // onRegisterUser(params)
                }}>
                <div className="form-group pt-2 autocomp">
                  <label htmlFor="defAddress" className="pb-1">آدرس پیشفرض *<span className="text-danger">{state?.findAddress}</span></label>
                  <p type="email" className="form-control" style={{ height: '3rem' }} placeholder="آدرس پیشفرض"
                    onKeyDown={handleEnter}
                  >
                    {!state?.defAddress ? "آدرس پیشفرض" : state?.defAddress}
                  </p>
                </div>

              </AddOriginAddress>


              <div className="form-group pt-2 autocomp">
                <label htmlFor="mail" className="pb-1">پست الکترونیکی</label>
                <input type="email" className="form-control" name="mail" placeholder="پست الکترونیکی"
                  onKeyDown={handleEnterToSubmit}
                  onChange={onInputChange} />
              </div>

              <div className="form-group pt-2 autocomp">
                <label htmlFor="tel" className="pb-1">تلفن ثابت</label>
                <input type="number" className="form-control" name="tel" placeholder="تلفن ثابت"
                  onKeyDown={handleEnterToSubmit}
                  onChange={onInputChange} />
              </div>

            </form>

            {/* <div className="col-12  justify-content-center align-items-center d-flex mt-2">
              <Captcha onChallengeId={setChallengeId} />
            </div> */}

            {
              loading ?
                <div className="col-12  justify-content-center align-items-center d-flex mt-2">
                  <div className="spinner-border text-primary " />
                </div>
                :
                <div>


                  <button to="/"
                    ref={submit}
                    className="btn btn-success iranSansBold col-12 mt-2 arcaptcha"
                    onClick={() => { onRegisterUser(state) }}
                  >ثبت نام</button>

                </div>
            }

            <div className="mt-2">
              <label className="form-check-label px-1 my-0 mt-1  "
                style={{ cursor: 'pointer' }}
                htmlFor="saveCheck"
                onClick={() => { navigate(paths.login) }}>قبلا ثبت نام کرده ام </label>
              <label className="form-check-label px-1 my-0 mt-1 text-success iranSansBold  "
                style={{ cursor: 'pointer' }}
                htmlFor="saveCheck"
                onClick={() => { navigate(paths.login) }}>وارد شوید  </label>
            </div>
          </div>
          <small className="form-text text-white text-shadow " style={{ zIndex: '1000', textShadow: '2px 2px #000000' }}>1401 © توسعه و اجرا توسط شرکت <a href="http://efspco.ir" target="_blank" className="">ابتکار فناوران سهند پویا</a> </small>

        </div>

      </div>

    </div>

  );

}